module.exports = __webpack_public_path__ + "img/Freek_proost.6fd56337.jpg";